import { z } from "zod";
/** Branded string IDs — format validated at boundaries. */
export const AgencyIdSchema = z.string().min(1).brand();
export const ProjectIdSchema = z.string().min(1).brand();
export const BusinessGraphIdSchema = z.string().min(1).brand();
export const RunIdSchema = z.string().min(1).brand();
export const RevisionIdSchema = z.string().min(1).brand();
export const ClientLinkIdSchema = z.string().min(1).brand();
export const TraceIdSchema = z.string().min(1).brand();
export const CorrelationIdSchema = z.string().min(1).brand();
export const ReportIdSchema = z.string().min(1).brand();
export const ScanIdSchema = z
    .string()
    .regex(/^scan_[a-zA-Z0-9_-]+$/)
    .brand();
//# sourceMappingURL=ids.js.map